import StyleControls from './StyleControls';

export default StyleControls;
